import(/* webpackMode: "eager" */ "/home/ubuntu/test-adaption/src/widgets/login/AuthForm.tsx")